import React, { Component } from "react";
import { connect } from "react-redux";
import {
  deleteCurrentUser,
  logout
} from "state/currentUser/currentUserActions";
import DeleteUserButton from "./DeleteUserButton";

export class DeleteUserButtonContainer extends Component {
  onDeleteUser = () => {
    // First delete the user account, then logout on success
    this.props.onDeleteUser({
      onSuccess: () => {
        this.props.logout();
      }
    });
  };

  render() {
    return <DeleteUserButton onDeleteUser={this.onDeleteUser} />;
  }
}

const mapStateToProps = () => {};

const mapDispatchToProps = dispatch => {
  return {
    onDeleteUser: args => dispatch(deleteCurrentUser(args)),
    logout: args => dispatch(logout(args))
  };
};

DeleteUserButtonContainer.displayName = "DeleteUserButtonContainer";
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteUserButtonContainer);
